export default __webpack_public_path__ + "static/media/strawberry.470131c1.jpg";